var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import EntrustDeliverService from '../../api/EntrustDeliverService';
import CommonService from '../../api/CommonService';
import GoodTable from './GoodTable.vue';
import { toDetail } from '../../helper/util';
import { EBillType } from '../../enum/EBillType';
import ELogisticsType from '../../enum/ELogisticsType';
import { auth } from '../../helper/authDecorator';
import { nameDict } from '../../constant/authCode';
import { Loading } from 'element-ui';
import { mapGetters } from 'vuex';
var DeliverDetail = (function (_super) {
    __extends(DeliverDetail, _super);
    function DeliverDetail() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.rowId = null;
        _this.tableHeight = 300;
        _this.billData = {
            order: '',
            business: '',
            phone: '',
            sender: '',
            total: '',
            status_text: '',
            order_date: '',
            send_date: '',
            purchaser: '',
            senderPhone: '',
            address: '',
            comment: '',
            logistics_type: '',
            sorting_order: [],
            organ_name: '',
            out_depot_name: '',
            order_icomment: '',
            is_sorting: '',
        };
        _this.goodData = [];
        _this.shopGoodData = [];
        _this.orderGoodData = [];
        _this.defaultType = 'byGood';
        _this.eLogisticsType = ELogisticsType;
        _this.supplierGoodsTypeList = [];
        _this.goodsFormData = {
            goods_type_id: undefined,
            keyword: '',
        };
        return _this;
    }
    DeliverDetail.prototype.mounted = function () {
        var _this = this;
        this.service = EntrustDeliverService.getInstance();
        this.commonService = CommonService.getInstance();
        setTimeout(function () {
            _this.tableHeight = document.documentElement.clientHeight - 240;
        }, 300);
        this.getDetail();
        this.getGoodsTypeList();
    };
    DeliverDetail.prototype.normalizer = function (node) {
        return {
            id: node.goods_type_id,
            label: node.goods_type_name,
            children: node.children,
        };
    };
    DeliverDetail.prototype.search = function () {
        this.getDetail();
    };
    DeliverDetail.prototype.getGoodsTypeList = function () {
        var _this = this;
        this.commonService.getSupplierGoodsTypeList().then(function (res) {
            if (res.data.success) {
                _this.supplierGoodsTypeList = res.data.data;
            }
            else {
                _this.$message.error(res.data.msg);
            }
        }, function (err) {
            _this.$message.error(err.message || err.msg);
        }).catch(function (err) {
            _this.$message.error(err.message);
        });
    };
    DeliverDetail.prototype.getDetail = function () {
        var _this = this;
        var params = {
            sort_field: this.order ? this.order[0] : undefined,
            sort_type: this.order ? this.order[1] : undefined,
            order_id: this.rowId,
            goods_type_id: this.goodsFormData.goods_type_id,
            keyword: this.goodsFormData.keyword,
        };
        var loadingInstance = Loading.service({ fullscreen: true });
        this.service
            .getDetail(params)
            .then(function (res) {
            var data = res.data.data;
            _this.billData = data;
            _this.goodData = data.goods_items;
            _this.shopGoodData = data.goods_shop_items;
            _this.orderGoodData = data.goods_order_items;
            _this.goodData.map(function (item) {
                if (item.order_detail_diff <= 0)
                    item.order_detail_diff = 0;
            });
            loadingInstance.close();
        })
            .catch(function (err) {
            loadingInstance.close();
            _this.$message.error(err.message || err.msg);
        });
    };
    DeliverDetail.prototype.toPurOrderDetail = function (id) {
        toDetail(EBillType.PurOrder, id);
    };
    DeliverDetail.prototype.toPurInDetail = function (id) {
        toDetail(EBillType.PurIn, id);
    };
    DeliverDetail.prototype.sortChange = function (_a) {
        var column = _a.column, prop = _a.prop, order = _a.order;
        if (!prop) {
            this.order = null;
        }
        else {
            this.order = [prop, order === 'ascending' ? 'asc' : 'desc'];
        }
        this.getDetail();
    };
    DeliverDetail = __decorate([
        auth(nameDict['委托送货单']),
        Component({
            filters: {
                total: function (row) {
                    var total = (row.price * row.send_amount).toFixed(2);
                    return isNaN(total) ? 0 : total;
                },
            },
            components: {
                GoodTable: GoodTable,
            },
            computed: __assign({}, mapGetters({
                serviceData: 'serviceData',
                serviceDataList: 'serviceDataList',
            })),
        })
    ], DeliverDetail);
    return DeliverDetail;
}(Vue));
export default DeliverDetail;
